module.exports = __webpack_public_path__ + "static/img/clippers.e432ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/certificates/clippers.jpg
// module id = 35
// module chunks = 0